export default class FileUploader {
  constructor(uploadUrl) {
    this.url = uploadUrl;
  }

  upload({
    token = '',
    channelId = '',
    message = '',
    onError,
    onProgress,
    onSuccess,
    teamId,
    teamUserId,
    attachments = null,
    important = false,
    inboxTaskId = null,
    quoteMessageId = null,
  }) {
    const xhr = new XMLHttpRequest();
    const formData = new FormData();

    formData.append('token', token);
    formData.append('channelId', channelId);
    formData.append('channel', channelId); // temp
    formData.append('message', message);
    if (teamId) formData.append('team_id', teamId);
    if (teamUserId) formData.append('user_id', teamUserId);
    if (important) formData.append('important', important);
    if (inboxTaskId) formData.append('inbox_task_id', inboxTaskId);
    if (quoteMessageId) formData.append('quote_message_id', quoteMessageId);

    function arrayToFormData(arr) {
      arr.forEach((object, i) => {
        Object.keys(object).forEach(key =>
          formData.append(`attachments[${i}][${key}]`, object[key]),
        );
      });
    }

    arrayToFormData(attachments);

    xhr.open('POST', this.url, true);
    xhr.setRequestHeader('platform', 'P_WEB');

    if (xhr.upload && onProgress) {
      xhr.upload.onprogress = onProgress;
    }

    xhr.onerror = handleError;

    xhr.onload = function() {
      if (xhr.status === 404) return handleError();
      onSuccess && onSuccess(xhr.responseBody, xhr); // eslint-disable-line no-unused-expressions
    };
    xhr.send(formData);

    // helper
    function handleError() {
      onError && onError(new Error(xhr.responseBody)); // eslint-disable-line no-unused-expressions
    }

    return xhr.abort.bind(xhr);
  }
}



// WEBPACK FOOTER //
// ./src/utils/chatAPI/attachments/file_uploader.js